module.exports = __webpack_public_path__ + "static/media/ba_contact_me.a28e9287.png";